import { render, staticRenderFns } from "./ChipBlocked.vue?vue&type=template&id=4b83ac54"
import script from "./ChipBlocked.vue?vue&type=script&lang=js"
export * from "./ChipBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports